import { useEffect } from 'react';
import { version as incomingVersion } from '../../../package.json';
import Cookies from 'js-cookie';
import { deleteStorages } from '@shared/utils';
import { LocalStorageKeys } from '@shared/constants';

/*
 * Whenever a new build is generated
 * along with it a new package.json["version"] is created
 * this is compared with localStorage version
 * if mismatched, browser cache is deleted and replaced with new cache
 */

export function useCacheBuster() {
  useEffect(() => {
    const oldVersion = localStorage.getItem('version');

    if (!oldVersion) {
      console.info('Cache Buster: No old version, registering new cache anyway');
      deleteOldCacheAndReload();
      return;
    }

    if (oldVersion !== incomingVersion) {
      console.info("Cache Buster: Version mismatch, let's remove site data.");
      deleteOldCacheAndReload();
      return;
    }

    console.info('Cache Buster: No new version, supplying old cache');
  }, []);
}

async function deleteOldCacheAndReload() {
  caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))));
  // store new cache
  localStorage.setItem('version', incomingVersion);

  window.location.reload();
}

export function resetAppStorage() {
  (async () => {
    const claimNumberSkipped = localStorage.getItem(LocalStorageKeys.claimNumberSkipped);
    deleteStorages();

    // 1. Clear Local Storage
    localStorage.clear();

    if (claimNumberSkipped) {
      localStorage.setItem(LocalStorageKeys.claimNumberSkipped, claimNumberSkipped);
    }

    // 2. Clear Session Storage
    sessionStorage.clear();

    // 3. Delete all cookies
    Object.keys(Cookies.get()).forEach((name) => {
      Cookies.remove(name);
    });

    // 4. Clear IndexedDB
    if (window.indexedDB && indexedDB.databases) {
      const dbs = await indexedDB.databases();
      dbs.forEach((db) => {
        if (db.name) indexedDB.deleteDatabase(db.name);
      });
    }

    // 5. Clear Cache Storage (Service Worker caches)
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    // 6. Unregister Service Workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach((reg) => reg.unregister());
    }

    console.info('Cache Buster: New version found, reloading...');
    console.info('App storage reset complete.');
    deleteOldCacheAndReload();
  })();
}
